module.exports = __webpack_public_path__ + "img/19.aa80fc2e.png";